import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import LoadingProgress from '../components/LoadingProgress'

import { fetchMatrixs } from '../actions/matrixs'

import MatrixList from '../components/MatrixList'
import BluetoothList from '../components/BluetoothList'
import ErrorMessage from '../components/ErrorMessage'

class MatrixsView extends React.Component {
  constructor(props) {
    super(props)
    this.state = { activeTab: 'firmware' }
  }

  componentDidMount() {
    this.props.fetchMatrixs('')
  }

  renderContent() {
    const { matrixs, error, loading } = this.props

    if (error) {
      return <ErrorMessage message={error.message} />
    }

    if (!matrixs || loading) {
      return <LoadingProgress />
    }

    if (this.state.activeTab === 'firmware') {
      return <MatrixList matrixs={matrixs} />
    }

    return <BluetoothList matrixs={matrixs} />
  }

  render() {
    return (
      <div>
        <div className="mach-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-microchip mr-2"></i>
                <span className="text-vw-dark">Versiones de Firmware</span>
              </h1>
            </div>
          </div>
        </div>

        <div className="od-page-nav">
          {[
            { id: 'firmware',   icon: 'fa-microchip',    label: 'Firmware'          },
            { id: 'bluetooth',  icon: 'fa-bluetooth-b',  label: 'Fallos Bluetooth'  },
          ].map(t => (
            <button
              key={t.id}
              className={`od-page-tab${this.state.activeTab === t.id ? ' active' : ''}`}
              onClick={() => this.setState({ activeTab: t.id })}
            >
              <i className={`fas ${t.icon}`}></i>
              <span>{t.label}</span>
            </button>
          ))}
        </div>

        <div style={{ padding: '16px 0' }}>
          {this.renderContent()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  matrixs: state.matrixs.matrixs,
  error: state.matrixs.error,
  loading: state.matrixs.loading,
  role: state.auth.role,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(MatrixsView)
